function NoListDataAvailable({ type }) { 
    return ( 
        <>
            <tr>
                <td colSpan="12" style={{ textAlign: 'center', padding: '10px' }}>
                    No {type} available 
                </td>
            </tr> 
        </>
    ); 
} 
export default NoListDataAvailable;